import React, { Component } from 'react';
import { connect } from 'react-redux';
import { styled } from '@mui/material/styles';

import i18n from 'app/common/i18n';

import { setTitle } from 'app/layout/redux';
import PaymentDashboard from './dashboard';

const Root = styled('div')(({ theme }) => ({
  '& .payments-root': {
    width: '100%',
    marginTop: theme.spacing(3),
    overflowX: 'auto'
  },

  '& .payments-table': {
    minWidth: 500
  }
}));

const classes = {
  root: 'payments-root',
  table: 'payments-table'
};

@connect(({}) => ({}), { setTitle })
@i18n
class Payments extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.setTitle(this.props.i18n('Payments'));
  }

  render() {
    return (
      <Root>
        <PaymentDashboard classes={classes} i18n={this.props.i18n} />
      </Root>
    );
  }
}

export default Payments;
